export default __webpack_public_path__ + "static/media/Butt_Pain.dae65986.jpg";